module.exports = __webpack_public_path__ + "img/big_1_54.e4e9269c.png";